// Single source of truth for parsing a FlatInterestRequest.dueDate string.
//
// The landlord's Accept dialog picks a date, but the request thunk
// (UpdateInterestRequestStatus, in this same reducer folder) reformats it to
// "DD-MM-YYYY" via moment before it's sent — that's what's actually stored.
// Parsing by "whichever segment is the 4-digit one is the year" copes with
// that and with any stray "YYYY-MM-DD" value alike, without needing to know
// in advance which shape a given record used.
export const parseDueDate = (dueDateStr) => {
  if (!dueDateStr) return null;

  const parts = String(dueDateStr).split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null;

  const [a, b, c] = parts;
  const [year, month, day] = a > 31 ? [a, b, c] : [c, b, a];
  if (!year || !month || !day) return null;

  // End of the due day, not the start — the tenant has until midnight of
  // that day to pay. Built in local time: `new Date("2026-08-02")` parses as
  // UTC midnight, which in PKT (UTC+5) is 05:00 the same morning.
  return new Date(year, month - 1, day, 23, 59, 59, 999);
};

export const isPastDueDate = (dueDateStr) => {
  const deadline = parseDueDate(dueDateStr);
  return deadline ? deadline.getTime() < Date.now() : false;
};

export const isDueToday = (dueDateStr) => {
  const deadline = parseDueDate(dueDateStr);
  if (!deadline) return false;

  const now = new Date();
  return (
    deadline.getDate() === now.getDate() &&
    deadline.getMonth() === now.getMonth() &&
    deadline.getFullYear() === now.getFullYear()
  );
};
